import { useContext, createContext, useState, useEffect } from "react";

const AuthContext = createContext({
    isAuthenticated: false,
});

export function AuthProvider({ children }) {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const token = getToken();
        if (token) {
            saveAuth(true);
        }
    });

    function saveToken(token) {
        localStorage.setItem("token", token);
    }

    function getToken() {
        return localStorage.getItem("token");
    }

    function saveCompany(company) {
        localStorage.setItem("company", company);
    }

    function getCompany() {
        return localStorage.getItem("company");
    }

    function deleteToken() {
        return localStorage.removeItem("token");
    }

    function deleteCompany() {
        return localStorage.removeItem("company");
    }

    function saveAuth(value) {
        setIsAuthenticated(value)
    }

    return <AuthContext.Provider value={{ isAuthenticated, saveAuth, saveToken, getToken, deleteToken, saveCompany,  getCompany, deleteCompany}}>
        {children}
    </AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);